import { UseMutationResult, useMutation, UseQueryResult, useQuery, QueryClient } from '@tanstack/react-query'
import {
  CreateProductInput,
  CreateProductResponse,
  DeleteProductResponse,
  GetProductByIdResponse,
  GetProductListInput,
  GetProductListResponse,
  UpdateProductInput,
  UpdateProductStatusInput,
  UpdateStatusProductResponse,
} from 'services/interface'
import { crateProduct, deleteProduct, getProductById, getProductList, updateProduct, updateStatusProduct } from 'services/productApi'





export const useCreateProduct = (): UseMutationResult<
  CreateProductResponse,
  Error,
  CreateProductInput,
  unknown
> => {
  const queryClient = new QueryClient();
  return useMutation<CreateProductResponse, Error, CreateProductInput, unknown>({
    mutationFn: (input: CreateProductInput) => crateProduct(input),
    onSuccess: () => {
      queryClient.refetchQueries({ queryKey: ['getProductList'], type: 'all' });
      queryClient.refetchQueries({ queryKey: ['getProductListInActive'], type: 'all' });
      queryClient.refetchQueries({ queryKey: ['getProductListApprove'], type: 'all' });
      // Handle success
    },
  })
}

export const useGetProductList = (
  input: GetProductListInput
): UseQueryResult<GetProductListResponse, Error> => {
  return useQuery<GetProductListResponse, Error>({
    queryKey: ['getProductList', input.is_active, input.is_approve],
    queryFn: () => getProductList(input),
    // staleTime: 1000 * 60 * 60 * 24,
  })
}

export const useGetProductListInActive = (
  input: GetProductListInput
): UseQueryResult<GetProductListResponse, Error> => {
  return useQuery<GetProductListResponse, Error>({
    queryKey: ['getProductListInActive', input.is_active, input.is_approve,],
    queryFn: () => getProductList(input),
    // staleTime: 1000 * 60 * 60 * 24,
  })
}

export const useGetProductListApprove = (
  input: GetProductListInput
): UseQueryResult<GetProductListResponse, Error> => {
  return useQuery<GetProductListResponse, Error>({
    queryKey: ['getProductListApprove', input.is_active, input.is_approve,],
    queryFn: () => getProductList(input),
    // staleTime: 1000 * 60 * 60 * 24,
  })
}



//delete product
export const useDeleteProduct = (): UseMutationResult<
  DeleteProductResponse,
  Error,
  string,
  unknown
> => {
  const queryClient = new QueryClient();
  return useMutation<DeleteProductResponse, Error, string, unknown>({
    mutationFn: (id: string) => deleteProduct(id),
    onSuccess: () => {
      queryClient.refetchQueries({ queryKey: ['getProductList'], type: 'all' });
      queryClient.refetchQueries({ queryKey: ['getProductListInActive'], type: 'all' });
      queryClient.refetchQueries({ queryKey: ['getProductListApprove'], type: 'all' });
    },
  })
}


export const useGetProductById = (
  productId: string
): UseQueryResult<GetProductByIdResponse, Error> => {
  return useQuery<GetProductByIdResponse, Error>({
    queryKey: ['product', productId],
    queryFn: () => getProductById(productId),
    // staleTime: 1000 * 60 * 60 * 24,
  })
}

export const useUpdateProduct = (): UseMutationResult<
  CreateProductResponse,
  Error,
  UpdateProductInput,
  unknown
> => {
  const queryClient = new QueryClient();
  return useMutation<CreateProductResponse, Error, UpdateProductInput, unknown>({
    mutationFn: (input: UpdateProductInput) => updateProduct(input),
    onSuccess: () => {
      queryClient.refetchQueries({ queryKey: ['getProductList'], type: 'all' });
      queryClient.refetchQueries({ queryKey: ['getProductListInActive'], type: 'all' });
      queryClient.refetchQueries({ queryKey: ['getProductListApprove'], type: 'all' });
    },
  })
}

export const useUpdateStatusProduct = (): UseMutationResult<
  UpdateStatusProductResponse,
  Error,
  UpdateProductStatusInput,
  unknown
> => {
  const queryClient = new QueryClient();
  return useMutation<UpdateStatusProductResponse, Error, UpdateProductStatusInput, unknown>({
    mutationFn: (input: UpdateProductStatusInput) => updateStatusProduct(input),
    onSuccess: () => {
      queryClient.refetchQueries({ queryKey: ['getProductList'], type: 'all' });
      queryClient.refetchQueries({ queryKey: ['getProductListInActive'], type: 'all' });
      queryClient.refetchQueries({ queryKey: ['getProductListApprove'], type: 'all' });
    },
  })
}


